'use client';

import Text, { TextTag, TEXT_VARIANT } from '@pixum/text';
import Button, { ButtonVariants } from '@pixum/button';
import Icon from '@pixum/icon';
import { useUIStore } from 'stores/ui';
import styles from './CancellationLoginBanner.module.css';

interface CancellationLoginBannerProps {
  constants: Record<string, string>;
}

/**
 * Informational banner shown to unauthenticated users in the cancellation topic.
 * Prompts the user to log in before they can select orders and products for revocation.
 * Triggers the authentication dialog on button click via the UIStore.
 *
 * @param constants - CMS i18n strings for the banner text and login button label
 */
export function CancellationLoginBanner({ constants }: CancellationLoginBannerProps) {
  const { setAuthUIVisibility } = useUIStore(state => state);

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <Icon className={styles.lockIcon} name="lock" ariaHidden />
        <Text className={styles.text} tag={TextTag.SPAN} variant={TEXT_VARIANT.CAPTION}>
          {constants.cancelOrderLoginBannerText}
        </Text>
      </div>
      <Button
        label={constants.cancelOrderLoginBannerButton}
        variant={ButtonVariants.PRIMARY}
        type="button"
        onClick={() => setAuthUIVisibility(true)}
      >
        <Icon name="user" color="var(--color-on-primary, white)" ariaHidden />
        <span>{constants.cancelOrderLoginBannerButton}</span>
      </Button>
    </div>
  );
}
